import { render } from "./FormSelect.vue?vue&type=template&id=18bd13fe&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-18bd13fe"

export default script